import { useAuth } from '../contexts/AuthContext';

/**
 * Must stay in sync with server/src/security/adminPermissions.ts
 * ADMIN_EXCLUDED_PERMISSION_KEYS. Admin does not auto-hold these; they follow
 * the role checkboxes like any other role.
 */
const ADMIN_OPT_IN_PERMISSION_KEYS = new Set([
  'submission:dailylog_rb_self_approve',
  'submission:dailylog_mechanic_self_approve',
  'pcr:internal_notify',
  'quantified:sign_work_only',
]);

export const usePermissions = () => {
  const { currentUser, loading } = useAuth();

  const hasPermission = (permissionKey: string): boolean => {
    // Don't check permissions while still loading
    if (loading) {
      return false;
    }

    if (!currentUser) {
      return false;
    }

    const roleName = typeof currentUser.role === 'string'
      ? currentUser.role
      : currentUser.role?.name;
    const isAdmin = (roleName || '').trim().toLowerCase() === 'admin';
    if (isAdmin && !ADMIN_OPT_IN_PERMISSION_KEYS.has(permissionKey)) {
      return true;
    }

    // Check permissions array first (proper relationship)
    if (currentUser.permissions?.some(p => p.key === permissionKey)) {
      return true;
    }

    // Fallback to access array for backward compatibility
    if (currentUser.access?.includes(permissionKey)) {
      return true;
    }

    return false;
  };

  return {
    hasPermission,
    /** True while initial auth check is in progress; callers should avoid treating denied permissions as final until this is false. */
    loading,
  };
}; 